
import api from './axiosInstance'

const toKebab = (str:string) => str.replace(/_/g, '-')

export const AdminApi = {
    getTables: () => api.get('/admin/tables'),

    getSchema: (table:string) => api.get(`/admin/schema/${table}`),

    getData: (table:string) => api.get(`/admin/data/${table}`),

    create: (table:string, data: any) => api.post(`/${toKebab(table)}`, data).catch(err => console.error("Api error: ", err.response?.data || err)),

    createFormData: (table:string, formData: FormData) => api.post(`/${table}/upload`,  formData, {
        headers: {"Content-Type": "multipart/form-data"}
    }).catch(err => console.error("Api error: ", err.response?.data || err)),

    update: (table:string,id: number, data: any) => api.patch(`/${toKebab(table)}/${id}`, data)
    .catch(err => console.error("Api error: ", err.response?.data || err)),
    

    updateFormData: (table:string, id: number, formData: FormData) =>
        api.patch(`/${table}/upload/${id}`, formData,{
            headers: {"Content-Type":"multipart/form-data"}
        }).catch(err => console.error("Api error: ", err.response?.data || err)),

    remove:(table:string, id:number) => api.delete(`/admin/data/${table}/${id}`)





}